import React, { useState } from 'react';
import '../css/navbar.css';
import { questions } from '../config/data';
import { MdOutlineMenu } from "react-icons/md";
import { MdMenuOpen } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";

const Navbar = () => {
    // State to manage the `close` class on the nav element
    const [isClosed, setIsClosed] = useState(true);
    // State to manage dark mode

    // Toggle the `close` class
    const handleToggle = () => {
        setIsClosed(!isClosed);
    };

    return (
        <nav className={`shell ${isClosed ? 'close' : ''}`}>
            <header>
                <i className="toggle-small" onClick={handleToggle}>{isClosed ? <MdOutlineMenu/>: <MdMenuOpen/>}</i>
                <div className="image-text">
                    <span className="image">
                        <img src="/images/site_icon.jpg" alt="" />
                    </span>
                    <div className="text logo-text">
                        <span className="name">NekoMeme</span>
                        <span className="software">-Hear like a cat-</span>
                    </div>
                </div>
                <i className="toggle" onClick={handleToggle}><MdOutlineKeyboardArrowRight /></i>
            </header>

            <div className="menu-bar">
                <div className="menu">
                    <ul className="menu-links">
                        {Object.keys(questions).map((qSetKey) => {
                            const { id, icon, title} = questions[qSetKey];
                            return (
                                <li className="nav-link" key={id}>

                                    <a href={`#${qSetKey}`}>
                                        <i className="icon">{icon}</i>
                                        <span className="text nav-text">{title}</span>
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
